const B_1 = [
    {
        title: '服务评价',
        path: '/bidding/projectflow/dingbiao/servicevaluation/list'
    }
]
export default {
    path: 'servicevaluation',
    component: () => import(/*webpackChunkName: 'bidding-ding-cjyygl'*/ '@layout/empty'),
    children: [
        {
            path:"list",
            component: () => import('@views/bidding/views/project-flow/ding/servicevaluation/list'),
            meta: {
                title: '服务评价',
                bread: B_1
            },
        },
         {
             path:"form",
             component: () => import('@views/bidding/views/project-flow/ding/servicevaluation/components/form'),
             meta: {
                 title: '服务评价',
                 bread: B_1
             },
         },
    ]
}